import { useState } from "react";
import { fetchJobLookup } from "../services/api";

export default function JobLookup() {
  const [jobId, setJobId] = useState("");
  const [hubSpotData, setHubSpotData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!jobId) return;

    setLoading(true);
    setError(null);
    setHubSpotData(null);

    try {
      const data = await fetchJobLookup(Number(jobId));
      setHubSpotData(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div style={{ padding: "2rem", maxWidth: 900 }}>
      <h1>Facilis → HubSpot</h1>

      <form onSubmit={handleSubmit} style={{ marginBottom: "1rem" }}>
        <label>
          Job ID:
          <input
            type="number"
            value={jobId}
            onChange={(e) => setJobId(e.target.value)}
            style={{ marginLeft: "0.5rem" }}
          />
        </label>

        <button type="submit" disabled={loading || !jobId}>
          {loading ? "Loading..." : "Send Job ID to Hubspot"}
        </button>

      </form>

      {error && (
        <div style={{ color: "red", marginBottom: "1rem" }}>
          {error}
        </div>
      )}

      {hubSpotData && (
        <>
          <h2>Response (Raw JSON)</h2>
          <pre
            style={{
              background: "#f4f4f4",
              padding: "1rem",
              maxHeight: 400,
              overflow: "auto",
            }}
          >
            {JSON.stringify(hubSpotData, null, 2)}
          </pre>
        </>
      )}
    </div>
  );
}